import { h, Host } from "@stencil/core";
/**
 * The `ch-grid-rowset-legend` component represents a caption for the `ch-grid-rowset` element.
 * @deprecated Use `ch-tabular-grid` component instead. Use `ch-tabular-grid-rowset-legend` instead.
 */
export class ChGridRowsetLegend {
    /**
     * Event emitted when the legend is clicked.
     */
    rowsetLegendClicked;
    clickHandler() {
        this.rowsetLegendClicked.emit();
    }
    render() {
        return (h(Host, { key: '33d0456507e637b632fa38a3a08a2f3148509e20' }, h("div", { key: 'bc631704719b453fc980b0872814ac9aa7c0775a', part: "caret" }), h("label", { key: '6e3e127c78da90342a7703e73bb92c45a085feb2', part: "selector-label" }, h("input", { key: '84cf4d518e8bf24a98050d71965052386dece008', type: "checkbox", part: "selector" })), h("div", { key: '52b353351b8446dfd291d203eb47eb27ea286fe4', part: "icon" }), h("slot", { key: '5282dd2db742f93a542fc11904f1706dcbf68401' })));
    }
    static get is() { return "ch-grid-rowset-legend"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["ch-grid-rowset-legend.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["ch-grid-rowset-legend.css"]
        };
    }
    static get events() {
        return [{
                "method": "rowsetLegendClicked",
                "name": "rowsetLegendClicked",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Event emitted when the legend is clicked."
                },
                "complexType": {
                    "original": "CustomEvent",
                    "resolved": "CustomEvent<any>",
                    "references": {
                        "CustomEvent": {
                            "location": "global",
                            "id": "global::CustomEvent"
                        }
                    }
                }
            }];
    }
    static get listeners() {
        return [{
                "name": "click",
                "method": "clickHandler",
                "target": undefined,
                "capture": false,
                "passive": true
            }];
    }
}
